<template>
    <section class="mc-card" aria-labelledby="customer-return-recent-title">
        <div class="mc-card__head">
            <div class="mc-return-recent__title">
                <h2 id="customer-return-recent-title" class="mc-card__title">Ultimi resi ricevuti</h2>
                <span v-if="returns.length" class="mc-status mc-status--neutral">{{ formatNumber(returns.length) }}</span>
            </div>
            <v-btn outlined aria-label="Aggiorna ultimi resi" :loading="loading" @click="load">
                <v-icon left>mdi-refresh</v-icon>Aggiorna
            </v-btn>
        </div>
        <mc-state-message v-if="error" state="error" :title="error" :text="returns.length ? 'Sono ancora visibili i dati caricati in precedenza.' : ''" @retry="load" />
        <div class="mc-scroll-x">
            <v-data-table
                v-if="!error || returns.length"
                dense
                class="mc-vtable"
                :headers="headers"
                :items="returns"
                item-key="numero"
                :loading="loading"
                :items-per-page="10"
                no-data-text="Nessun reso cliente disponibile"
            >
                <template #loading><mc-state-message state="loading" /></template>
                <template #no-data><mc-state-message state="empty" title="Nessun reso cliente disponibile" /></template>
                <template v-slot:[`item.numero`]="{ item }">
                    <span class="mc-code">{{ item.numero }}</span>
                </template>
                <template v-slot:[`item.data_reso`]="{ item }">
                    {{ formatDate(item.data_reso) }}
                </template>
                <template v-slot:[`item.cliente`]="{ item }">
                    <div class="mc-code">{{ item.cliente_codice }}</div>
                    <div class="mc-caption">{{ item.cliente }}</div>
                </template>
                <template v-slot:[`item.ddt_cliente`]="{ item }">
                    <div>{{ item.ddt_cliente || "—" }}</div>
                    <div v-if="item.data_ddt_cliente" class="mc-caption">{{ formatDate(item.data_ddt_cliente) }}</div>
                </template>
                <template v-slot:[`item.righe`]="{ item }">
                    <div v-for="line in item.righe" :key="`${item.numero}-${line.riga}`" class="mc-return-recent__line">
                        <div><span class="mc-code">{{ line.articolo }}</span><div class="mc-caption">{{ line.descrizione }}</div></div>
                        <span class="mc-return-recent__quantity">{{ formatQuantity(line.quantita, line.unita_misura) }}</span>
                    </div>
                </template>
            </v-data-table>
        </div>
    </section>
</template>

<script>
import McStateMessage from "@/assets/mecom/vue/McStateMessage.vue";
import { date, number, withUnit } from "@/assets/mecom/js/format.mjs";

export default {
    name: "CustomerReturnRecent",
    components: { McStateMessage },
    data: () => ({
        returns: [],
        loading: false,
        error: "",
        headers: [
            { text: "Reso Sage", value: "numero", width: 145 },
            { text: "Data reso", value: "data_reso", width: 120 },
            { text: "Cliente", value: "cliente", width: 240, sortable: false },
            { text: "DDT cliente", value: "ddt_cliente", width: 160, sortable: false },
            { text: "Articoli ricevuti", value: "righe", sortable: false },
            { text: "Creato da", value: "creato_da", width: 120 },
        ],
    }),
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            this.error = "";
            try {
                const response = await this.$work.get("/arts/resi-cliente/recenti/");
                this.returns = response.data.resi;
            } catch {
                this.error = "Impossibile caricare gli ultimi resi ricevuti da Sage.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(value) {
            return date(value);
        },
        formatNumber(value) {
            return number(value, 0);
        },
        formatQuantity(value, unit) {
            return withUnit(value === null || value === "" ? null : Number(value), unit, 3);
        },
    },
};
</script>
